export const TANGO_CARD_LOGO_URL =
  'https://d2syurifiadbgf.cloudfront.net/wp-content/themes/tc/uploads/tango-card-logo-gray.png'
